export default "__VITE_ASSET__CQZ89Q_$__"